/* V_NUF_LP_02 | Email Signup Popup on Main Landing Page (Email Team Test)
 * Control: no Klaviyo form, as before the email team's forms went live. Their containers
 * (popup and "Get 10% Off" tab) are marked so c-nuf-lp-02.css keeps them hidden for everyone
 * who is not in Var A, including before the group is known.
 * Var A (body.c-nufLp02VarA): the forms show as Klaviyo renders them (the tab), plus the popup
 * opens by itself, the mobile or desktop form by screen width, once the visitor has been on the
 * page for the set delay, or earlier on desktop exit intent. Never on page load, at most once
 * per session (including when the visitor already opened it from the tab), and never again
 * after a signup. All values come from the Liquid-rendered .c-nuf-lp-02-config.
 * Measurement: Klaviyo's "klaviyoForms" events show the view / signup markers that the
 * Intelligems events watch, for Var A only.
 */
(function () {
  var VAR_A = 'c-nufLp02VarA';
  var MARK = 'data-c-nuf-lp-02-popup';
  var SHOWN_KEY = 'c-nuf-lp-02-shown';
  var SIGNED_UP_KEY = 'c-nuf-lp-02-signed-up';
  var config;
  var formIds = [];
  var formId;
  var started = false;
  var opened = false;
  var popupOpen = false;
  var timer;

  function isVarA() {
    return document.body.classList.contains(VAR_A);
  }

  function read(storage, key) {
    try { return window[storage].getItem(key); } catch (e) { return null; }
  }

  function write(storage, key) {
    try { window[storage].setItem(key, '1'); } catch (e) { /* storage blocked: still opens once per page */ }
  }

  function showMarker(name) {
    var marker = document.querySelector('.c-nuf-lp-02-marker[data-c-marker="' + name + '"]');
    if (marker) marker.classList.add('is-active');
  }

  // Klaviyo renders each popup (and its tab) in its own container appended to <body>;
  // mark that container so the overlay is hidden along with the form
  function containerOf(el) {
    var node = el;
    while (node.parentElement && node.parentElement !== document.body) node = node.parentElement;
    if (node.parentElement === document.body && !node.querySelector('.fb-landing-root')) return node;
    return el.closest('[role="dialog"]') || el;
  }

  function markPopups(root) {
    formIds.forEach(function (id) {
      var selector = 'form[data-testid="klaviyo-form-' + id + '"], .klaviyo-form-' + id + ', .kl-teaser-' + id;
      var found = root.matches && root.matches(selector) ? [root] : [];
      root.querySelectorAll(selector).forEach(function (el) { found.push(el); });
      found.forEach(function (el) { containerOf(el).setAttribute(MARK, id); });
    });
  }

  function cancelAutoOpen() {
    opened = true;
    clearTimeout(timer);
    document.documentElement.removeEventListener('mouseleave', onExitIntent);
  }

  function open() {
    if (opened) return;
    cancelAutoOpen();
    write('sessionStorage', SHOWN_KEY);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  // Desktop exit intent: the pointer leaves the page through the top edge (towards tabs / URL bar)
  function onExitIntent(evt) {
    if (evt.clientY <= 0) open();
  }

  function onKlaviyoForm(evt) {
    var detail = evt.detail || {};
    if (formIds.indexOf(detail.formId) === -1) return;
    markPopups(document.body);
    if (detail.type === 'open' && isVarA()) {
      popupOpen = true;
      // Opened from the tab first: the visitor has seen it, so it does not open again by itself
      if (!opened) {
        cancelAutoOpen();
        write('sessionStorage', SHOWN_KEY);
      }
      showMarker('view');
    }
    if ((detail.type === 'submit' || detail.type === 'stepSubmit') && isVarA()) {
      write('localStorage', SIGNED_UP_KEY);
      showMarker('signup');
    }
  }

  function start() {
    if (started || !isVarA()) return;
    started = true;
    if (popupOpen) showMarker('view');
    if (opened || !formId || read('sessionStorage', SHOWN_KEY) || read('localStorage', SIGNED_UP_KEY)) return;

    // Delay counts from page load, not from when the group arrived
    var wait = Math.max(0, config.delay * 1000 - performance.now());
    timer = setTimeout(open, wait);
    if (config.exitIntent && !config.isMobile) {
      document.documentElement.addEventListener('mouseleave', onExitIntent);
    }
  }

  function init() {
    var el = document.querySelector('.c-nuf-lp-02-config');
    if (!el) return;
    var breakpoint = parseInt(el.getAttribute('data-c-breakpoint'), 10) || 0;
    config = {
      delay: parseFloat(el.getAttribute('data-c-delay')) || 0,
      exitIntent: el.getAttribute('data-c-exit-intent') === 'true',
      isMobile: window.matchMedia('(max-width: ' + breakpoint + 'px)').matches
    };
    formIds = [el.getAttribute('data-c-form-mobile'), el.getAttribute('data-c-form-desktop')].filter(Boolean);
    formId = el.getAttribute(config.isMobile ? 'data-c-form-mobile' : 'data-c-form-desktop');
    if (!formIds.length) return;

    window.addEventListener('klaviyoForms', onKlaviyoForm);
    markPopups(document.body);

    // MutationObserver callbacks run before the next paint, so a form is marked (and hidden
    // outside Var A) before it is ever drawn
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) markPopups(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    // The group arrives once Intelligems is ready
    start();
    if (!started) {
      var observer = new MutationObserver(function () {
        start();
        if (started) observer.disconnect();
      });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
